var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 512,
    height: 341.326,
    y: 85.337
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#6da544"
    },
    width: 512,
    height: 113.775,
    y: 85.337
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 512,
    height: 113.775,
    y: 312.888
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d80027"
    },
    d: "M300.345,220.383h-17.863c0.148,1.963,0.232,3.944,0.232,5.936c0,13.207-3.301,26.01-9.057,35.122 c-1.775,2.812-4.759,6.78-8.753,9.456v-50.514h-17.809v50.514c-3.994-2.677-6.977-6.646-8.753-9.456 c-5.756-9.113-9.056-21.915-9.056-35.122c0-1.992,0.085-3.974,0.232-5.936h-17.863c-0.115,1.953-0.177,3.932-0.177,5.936 c0.001,36.617,19.557,65.299,44.523,65.299s44.522-28.682,44.522-65.299C300.522,224.315,300.459,222.336,300.345,220.383z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 24.421,
    x: 44.522,
    y: 184.275
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 24.421,
    y: 184.275
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 24.421,
    x: 89.043,
    y: 184.275
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 24.421,
    x: 133.565,
    y: 184.275
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 24.421,
    x: 178.087,
    y: 184.275
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 24.421,
    x: 222.609,
    y: 184.275
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 24.421,
    x: 267.13,
    y: 184.275
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 24.421,
    x: 311.652,
    y: 184.275
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 24.421,
    x: 356.174,
    y: 184.275
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 24.421,
    x: 400.696,
    y: 184.275
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 24.421,
    x: 445.217,
    y: 184.275
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 24.421,
    x: 489.739,
    y: 184.275
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 25.534,
    x: 44.522,
    y: 302.191
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 25.534,
    y: 302.191
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 25.534,
    x: 89.043,
    y: 302.191
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 25.534,
    x: 133.565,
    y: 302.191
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 25.534,
    x: 178.087,
    y: 302.191
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 25.534,
    x: 222.609,
    y: 302.191
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 25.534,
    x: 267.13,
    y: 302.191
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 25.534,
    x: 311.652,
    y: 302.191
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 25.534,
    x: 356.174,
    y: 302.191
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 25.534,
    x: 400.696,
    y: 302.191
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 25.534,
    x: 445.217,
    y: 302.191
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 22.261,
    height: 25.534,
    x: 489.739,
    y: 302.191
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPer);
export default __webpack_public_path__ + "static/media/per.0fc1682bea9c04a9b819a11ceeb6b835.svg";
export { ForwardRef as ReactComponent };